export default {
  itemsLimit: 1000,
}



// WEBPACK FOOTER //
// ./src/lib/vue-virtual-scroller/config.js